module.exports = __webpack_public_path__ + "img/02_3_2_2.a5cf1608.png";